import React, { useContext } from 'react';
import { string } from 'prop-types';
import { KeyProductFeatures } from '@thd-olt-component-react/key-product-features';
import './productKpf.scss';
import { extend, QueryProvider, QueryContext } from '@thd-nucleus/data-sources';

export const ProductKpf = ({ itemId, storeId }) => {
  const { defaultVariables } = useContext(QueryContext) || {};

  return (
    <div className="product-kpf">
      <QueryProvider
        cacheKey="package-pod-product-kpf"
        dataSource="catalog"
        defaultVariables={defaultVariables.current}
      >
        <KeyProductFeatures
          itemId={itemId}
          storeId={storeId}
          minfeatures={2}
          maxfeatures={6}
          simple
          hideImage
          twoColumnGrid
          displaySimilarLinks={false}
        />
      </QueryProvider>
    </div>
  );
};

ProductKpf.propTypes = {
  itemId: string.isRequired,
  storeId: string.isRequired
};

ProductKpf.dataModel = extend({}, KeyProductFeatures);
ProductKpf.displayName = 'ProductKpf';
